import { observer } from 'mobx-react-lite';
import ElementRenderer from './ElementRenderer';
import type { ElementRendererProps } from './types';

export type { ElementRendererProps };
export default observer(ElementRenderer);
